{
  "data": {
    "email_support": "usasupport{'@'}planfred.com",
    "phone_number": "773 814 3606"
  },
  "feature": {
    "account": {
      "billing_data": {
        "company": "Company/Name"
      },
      "plan_selection": {
        "free": {
          "price": "$ 0 / free"
        },
        "maxi": {
          "price_per_month": "$ 235",
          "price_per_year": "$ 2,585"
        },
        "message_testphase_end": "",
        "midi": {
          "price_per_month": "$ 75",
          "price_per_year": " $ 825"
        },
        "mini": {
          "price_per_month": "$ 25",
          "price_per_year": "$ 275"
        },
        "online_course": "",
        "prime": {
          "price_per_month": "$ 385",
          "price_per_year": "$ 4,235"
        },
        "tax": ""
      }
    },
    "item": {
      "task_mailer": {
        "subject_prefix": "{projectTitle} - {taskTitle}"
      }
    }
  },
  "layout": {
    "footer": {
      "any_questions": "You have questions?"
    },
    "go_to_website_url": "https://{hostname}/en-us/"
  }
}